import { useRouter } from 'next/router'
import React from 'react'
import { FaChevronLeft } from 'react-icons/fa'
import styled from 'styled-components'
import { MEDIA } from 'utils'

const BackButtonContainer = styled.div`
  display: flex;
  align-items: center;
  color: var(--cobasi-blue);
  font-size: 16px;
  font-family: var(--primary-font);
  font-weight: 600;
  letter-spacing: 0.96px;
  cursor: pointer;

  & > span {
    margin-left: 15px;
    line-height: 16px;
  }

  @media screen and ${MEDIA.MOBILE} {
    font-size: 18px;
  }
`

const BackButton = ({ onClick }) => {
  const router = useRouter()

  const handleClick = onClick || (e => {
    e.preventDefault()
    router.back()
  })

  return (
    <BackButtonContainer onClick={handleClick}>
      <FaChevronLeft size={24} />
      <span>Voltar</span>
    </BackButtonContainer>
  )
}

export default BackButton
